const StateProvinces = [
  {
    Id: 1,
    Code: "AL",
    Name: "Alabama"
  },
  {
    Id: 2,
    Code: "AK",
    Name: "Alaska"
  },
  {
    Id: 4,
    Code: "AZ",
    Name: "Arizona"
  },
  {
    Id: 5,
    Code: "AR",
    Name: "Arkansas"
  },
  {
    Id: 7,
    Code: "CA",
    Name: "California"
  },
  {
    Id: 8,
    Code: "CO",
    Name: "Colorado"
  },
  {
    Id: 9,
    Code: "CT",
    Name: "Connecticut"
  },
  {
    Id: 10,
    Code: "DE",
    Name: "Delaware"
  },
  {
    Id: 11,
    Code: "DC",
    Name: "District of Columbia"
  },
  {
    Id: 13,
    Code: "FL",
    Name: "Florida"
  },
  {
    Id: 15,
    Code: "GA",
    Name: "Georgia"
  },
  {
    Id: 16,
    Code: "HI",
    Name: "Hawaii"
  },
  {
    Id: 17,
    Code: "ID",
    Name: "Idaho"
  },
  {
    Id: 18,
    Code: "IL",
    Name: "Illinois"
  },
  {
    Id: 19,
    Code: "IN",
    Name: "Indiana"
  },
  {
    Id: 20,
    Code: "IA",
    Name: "Iowa"
  },
  {
    Id: 21,
    Code: "KS",
    Name: "Kansas"
  },
  {
    Id: 23,
    Code: "KY",
    Name: "Kentucky"
  },
  {
    Id: 24,
    Code: "LA",
    Name: "Louisiana"
  },
  {
    Id: 25,
    Code: "ME",
    Name: "Maine"
  },
  {
    Id: 27,
    Code: "MD",
    Name: "Maryland"
  },
  {
    Id: 28,
    Code: "MA",
    Name: "Massachusetts"
  },
  {
    Id: 29,
    Code: "MI",
    Name: "Michigan"
  },
  {
    Id: 30,
    Code: "MN",
    Name: "Minnesota"
  },
  {
    Id: 31,
    Code: "MS",
    Name: "Mississippi"
  },
  {
    Id: 32,
    Code: "MO",
    Name: "Missouri"
  },
  {
    Id: 33,
    Code: "MT",
    Name: "Montana"
  },
  {
    Id: 34,
    Code: "NE",
    Name: "Nebraska"
  },
  {
    Id: 35,
    Code: "NV",
    Name: "Nevada"
  },
  {
    Id: 37,
    Code: "NH",
    Name: "New Hampshire"
  },
  {
    Id: 38,
    Code: "NJ",
    Name: "New Jersey"
  },
  {
    Id: 39,
    Code: "NM",
    Name: "New Mexico"
  },
  {
    Id: 40,
    Code: "NY",
    Name: "New York"
  },
  {
    Id: 42,
    Code: "NC",
    Name: "North Carolina"
  },
  {
    Id: 43,
    Code: "ND",
    Name: "North Dakota"
  },
  {
    Id: 47,
    Code: "OH",
    Name: "Ohio"
  },
  {
    Id: 48,
    Code: "OK",
    Name: "Oklahoma"
  },
  {
    Id: 50,
    Code: "OR",
    Name: "Oregon"
  },
  {
    Id: 52,
    Code: "PA",
    Name: "Pennsylvania"
  },
  {
    Id: 54,
    Code: "PR",
    Name: "Puerto Rico"
  },
  {
    Id: 56,
    Code: "RI",
    Name: "Rhode Island"
  },
  {
    Id: 59,
    Code: "SC",
    Name: "South Carolina"
  },
  {
    Id: 60,
    Code: "SD",
    Name: "South Dakota"
  },
  {
    Id: 61,
    Code: "TN",
    Name: "Tennessee"
  },
  {
    Id: 62,
    Code: "TX",
    Name: "Texas"
  },
  {
    Id: 63,
    Code: "UT",
    Name: "Utah"
  },
  {
    Id: 64,
    Code: "VT",
    Name: "Vermont"
  },
  {
    Id: 65,
    Code: "VA",
    Name: "Virginia"
  },
  {
    Id: 67,
    Code: "WA",
    Name: "Washington"
  },
  {
    Id: 68,
    Code: "WV",
    Name: "West Virginia"
  },
  {
    Id: 69,
    Code: "WI",
    Name: "Wisconsin"
  },
  {
    Id: 70,
    Code: "WY",
    Name: "Wyoming"
  }
]
const ccpaStates = ['CA']
let html = ''
let apiUrl = ''

if (window.location.hostname.includes("local") || window.location.hostname.includes("dev2")) {
  apiUrl = 'https://dev2.api.employeeworkplace.com/web-forms/'
} else if (window.location.hostname.includes("uat2")) {
  apiUrl = 'https://uat2.api.employeeworkplace.com/web-forms/'
} else {
  apiUrl = 'https://api.employeeworkplace.com/web-forms/'
}
let publicKey
let encryptedFile
let uploadedFileName = null
let uploadedFileMimeType = null
let fileStoreId = 0
window.onload = function () {
  // window.disableSubmitButton = disableSubmitButton
  const uploadSection = $('#file-upload')
  uploadSection.hide()
  const cancelBtn = document.querySelector('.fileinput-cancel-button')
  console.log('cancel btn')
  console.log(cancelBtn)
  cancelBtn.remove()
  const removeBtn = document.querySelector('.fileinput-remove-button')
  removeBtn.remove()
  const uploadBtn = document.querySelector('.fileinput-upload-button')
  uploadBtn.remove()
  // document.querySelector('.fileinput-new').show()
  var todaysDate = new Date();
  var newDateOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }
  todaysDate = todaysDate.toLocaleString('en-US',newDateOptions)

  function getUserOriginData() {
    let VisitorAPI = function (t, e, a) {
      var s = new XMLHttpRequest;
      s.onreadystatechange = function () {
        var t;
        s.readyState === XMLHttpRequest.DONE && (200 === (t = JSON.parse(s.responseText)).status ? e(t.data) : a(t.status, t.result))
      }, s.open("GET", "https://api.visitorapi.com/api/?pid=" + t), s.send(null)
    };

    VisitorAPI(
      "trppJDiR1VD9epeGa43i",
      function (data) {
        sessionStorage.setItem('userOriginData', JSON.stringify(data, null, 2));
      },
      function (errorCode, errorMessage) {
        console.log(errorCode, errorMessage)
      }
    );
    return
  }

  getUserOriginData();


  const displayVisitDateTime = document.getElementById("signatureDate")
  displayVisitDateTime.outerText = "Date: " + todaysDate

  const statesDropDown = document.getElementById('stateProvince')
  StateProvinces.map(stateProvince => {
    const option = document.createElement('option')
    option.text = stateProvince.Name
    option.value = stateProvince.Code
    statesDropDown.options.add(option)
  })

  $('#phoneNumber').keyup(function (event) {
    formatPhone(event.currentTarget.value)
  });

  function formatPhone(phone) {
    if (event.keyCode !== 8) {
      var curchr = phone.length;
      var curval = phone;
      if (curchr === 3) {
        $('#phoneNumber').val("(" + curval + ")" + " ");
      } else if (curchr === 9) {
        $('#phoneNumber').val(curval + "-");
      } else if (curchr === 10 && !curval.includes('(')) {
        const areaCode = curval.substring(0, 3)
        const phonePart1 = curval.substring(3, 6)
        const phonePart2 = curval.substring(6, 10)
        $('#phoneNumber').val("(" + areaCode + ")" + " " + phonePart1 + '-' + phonePart2)
      } else if (curchr >= 14 && !curval.includes('(')) {
        const areaCode = curval.substring(0, 3)
        const phonePart1 = curval.substring(4, 7)
        const phonePart2 = curval.substring(8, 12)
        $('#phoneNumber').val("(" + areaCode + ")" + " " + phonePart1 + '-' + phonePart2)
      }
    }
  }

  $('#emailAddress').change(function () {
    const re = /\S+@\S+\.\S+/
    let match = false
    match = re.test($('#emailAddress').val())
    if (!match) {
      $('#emailAddress').css('background-color', 'pink')
    } else {
      $('#emailAddress').css('background-color', 'white')
    }
  })

  $('#submitBtn').click(function (event) {
    'use strict'
    let submitForm = false;
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    let forms = document.querySelectorAll('.needs-validation')
    // check that at least 1 request box is checked
    let requestBoxChecked = false;
    if($('#confirmDelete').is(':checked') || $('#confirmCategories').is(':checked') || $('#confirmCollected').is(':checked') || $('#confirmCollected').is(':checked')){
      requestBoxChecked = true;
      $('#request-box-not-checked')[0].setAttribute('style', 'display: none')
      $('#request-checkboxes').css('border',0)
    } else {
      event.preventDefault()
      console.log('request box not checked')
      $('#request-box-not-checked')[0].setAttribute('style', 'display: block')
      $('#request-checkboxes').css('border','2px solid red')
    }
    if(requestBoxChecked){
      // Loop over them and prevent submission
      Array.prototype.slice.call(forms)
        .forEach(function (form) {
          if (!form.checkValidity()) {
            event.preventDefault()
            event.stopPropagation()
            let firstInvalid;
            let errorCheckbox = document.querySelectorAll("input.form-check-input:invalid");
            let errorOthers = document.querySelectorAll("input.form-control:invalid");
            if (errorCheckbox.length > 0)
              firstInvalid = $(form).find(".form-check-input:invalid").first()
            else if (errorOthers.length > 0)
              firstInvalid = $(form).find(".form-control:invalid").first()

            window.scrollTo({
              behavior: 'instant'
            });
            firstInvalid.focus();

          } else {
            submitForm = true;
          }
          form.classList.add('was-validated')
        })
    }

    // Get user stateProvince
    let selectedStateProvince = document.getElementById("stateProvince").value;
    console.log(selectedStateProvince);

    let stateFound = ccpaStates.find((state) => state == selectedStateProvince);

    console.log(stateFound);
    console.log(submitForm);

    if (submitForm) {
      if (!stateFound) {
        event.preventDefault()
        let modal = new bootstrap.Modal(document.getElementById('notApplicableModal'));
        modal.show();
        document.getElementById("notApplicableModal").classList.add("show");
      } else {
        event.preventDefault()
        $('#confirmation')[0].setAttribute('style', 'display: block')
      }
    }
  })


  $('#denied').click(function () {
    $('#confirmation')[0].setAttribute('style', 'display: none')
  })

  $('#accepted').click(function () {
    event.preventDefault()
    submitRequest()
  })

  function reloadPage() {
    location.reload();
  }
  function setHtmlValue() {

    html = '<!doctype html>' +
      '<html lang="en">' +
      '    <head>' +
      '        <meta charset="utf-8">' +
      '        <title>Web Forms</title>' +
      '        <base href="/web-forms/">' +
      '        <meta name="viewport" content="width=device-width, initial-scale=1">' +
      '        <link rel="icon" type="image/x-icon" href="favicon.ico">' +
      '        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"\n' +
      '        integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">' +
      '        <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500&display=swap" rel="stylesheet">' +
      '        <link rel="stylesheet" type="text/css" href="https://cdn.staffmarkcms.com/css/template-style.css"/>' +
      '        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">' +
      '    </head>' +
      '    <body>' +
      ' <form' +
      '  class=""' +
      '  id="requestForm"' +
      '  >' +

      '  <div class="container">' +

      '    <div class="row my-2 text-center">' +
      '      <div class="col-12">' +
      '        <img class="w-100 mb-4" src="https://employeeworkplace.com/web-forms/assets/logos/SMG_logo_brands_blue_box.png" alt="">' +
      '      </div>' +
      '    </div>' +

      '    <div class="row">' +
      '      <div class="col-12">' +
      '        <h1 class="mat-display-1 text-center mt-2">' +
      '          CCPA Consumer Request Form </h1>' +

      '                <div class="content-wrap">' +
      '          <p>If you are a California resident, the California Consumer Privacy Act (CCPA) permits California consumers' +
      '            ("you") to request the personal information held, the categories of personal information held, to delete or' +
      '            correct personal information.' +
      '            Please provide the following information so that we may process your request.' +
      '            If you would like to submit a request in an alternative format, you may also call: (866) 765-7544 or email' +
      '            AskPrivacy@staffmarkgroup.com.' +
      '          </p>' +
      '          <p>' +
      '            Your requests may be subject to exemptions or other legal requirements.' +
      '            For a more detailed explanation of your rights please visit our Privacy Policy. If you have any questions,' +
      '            you may also contact us at (866) 765-7544.' +
      '          </p>' +
      '        </div>' +
      '      </div>' +
      '    </div>' +
      '        <div class="row">' +
      '      <div class="col-12">' +
      '        <h2 class="h3">' +
      '          Request by Authorized Agent' +
      '        </h2>' +
      '        <div>' +
      '          <p>' +
      '            If you are an agent completing on behalf of a consumer, please <a target="_blank"' +
      '                                                                              href="https://content.employeeworkplace.com/Staffmark Group CCPA Consumer Request Form Submission by Authorized Agent (HR 516 B).pdf">click' +
      '            here</a> to download the request form and' +
      '            submit the request to <a href="mailto:AskPrivacy@Staffmarkgroup.com">AskPrivacy@Staffmarkgroup.com</a>.' +
      '          </p>' +
      '        </div>' +
      '      </div>' +
      '    </div>' +
      '    <div class="row">' +
      '      <div class="col-12">' +
      '        <h2 class="h3">' +
      '          Requests by Consumers' +
      '        </h2>' +
      '        <div>' +
      '          <p>' +
      '            In order to complete your request, please supply all information requested below. We need this information' +
      '            to verify your identity and to make sure we are deleting the appropriate personal information from our' +
      '            records. Once you have submitted the requested information, your submission serves as your authorization to' +
      '            complete your request. Depending on the nature of your request, we may request additional information to' +
      '            verify your identity or document' +
      '            your requested correction. If we are unable to verify your identity with the' +
      '            information provided your request may be denied.' +
      '          </p>' +
      '        </div>' +
      '      </div>' +
      '    </div>' +
      '</div>' +

      '  <div class="container">' +
    '  <form class="form mt-3" >' +
      '    <div class="row my-2">' +
      '      <div class="col-10 offset-1">' +
      '        <div class="form-check form-check-inline">' +
      '          <input class="form-check-input"' +
      '                 type="checkbox" id="confirmDeletePdf" value="option1" ';

    if ($('#confirmDelete').is(':checked')) {
      html += 'checked ';
    }

    html += '>' +
      '  <label class="form-label" for="confirmDeletePdf">I wish to have my personal information deleted</label>' +
      '        </div>' +
      '      </div>' +
      '    </div>' +
      '    <div class="row my-2">' +
      '      <div class="col-10 offset-1" >' +
      '        <div class="form-check form-check-inline">' +
      '          <input class="form-check-input"' +
      '                 type="checkbox" id="confirmCategoriesPdf" value="option2" style="margin-bottom:50px;" ';

    if ($('#confirmCategories').is(':checked')) {
      html += 'checked ';
    }

    html += '>' +
      '          <label class="form-label" for="confirmCategoriesPdf"> I request to know the categories of personal information,' +
      '            the sources of that information or the third parties to whom the information was disclosed. (Please specify' +
      '            what information you would to know about in the notes section of the form)</label>' +
      '        </div>' +
      '      </div>' +
      '    </div>' +
      '    <div class="row my-2">' +
      '      <div class="col-10 offset-1">' +
      '        <div class="form-check form-check-inline">' +
      '          <input class="form-check-input"' +
      '                 type="checkbox" id="confirmCollectedPdf" value="option3" ';

    if ($('#confirmCollected').is(':checked')) {
      html += 'checked ';
    }

    html +=
      '          <label class="form-label" for="confirmCollectedPdf"> I request to know the specific personal information' +
      '            collected in the preceding twelve months.</label>' +
      '        </div>' +
      '      </div>' +
      '    </div>' +
      '    <div class="row my-2">' +
      '      <div class="col-10 offset-1">' +
      '        <div class="form-check form-check-inline">' +
      '          <input class="form-check-input"' +
      '                 type="checkbox" id="confirmCorrectionPdf" value="option4" ';

    if ($('#confirmCollected').is(':checked')) {
      html += 'checked ';
    }

    html += '>' +
      '          <label class="form-label" for="confirmCorrectionPdf"> I request to have information corrected. (Please specify' +
      '            the information you would like corrected and please upload documentation establishing the inaccuracy of the' +
      '            information held).</label>' +
      '        </div>' +
      '      </div>' +
      '    </form>' +
      '    </div>';
    html +=
      '  <div class="container mt-2">' +
      '<div style="height:50px;">' +
      '</div>' +
      '<div class="row col-12">' +
      '    <div class="col-4" style="text-align: right;">' +
      '       <strong>Email Address:</strong>' +
      '    </div>' +
      '    <div class="col">' +
      $('#emailAddress').val() +
      '    </div>' +
      '</div>' +
      '<div class="row col-12 mt-1">' +
      '    <div class="col-4" style="text-align: right;">' +
      '       <strong>First Name:</strong>' +
      '    </div>' +
      '    <div class="col">' +
      $('#firstName').val() +
      '    </div>' +
      '</div>' +
      '<div class="row col-12 mt-1">' +
      '    <div class="col-4" style="text-align: right;">' +
      '       <strong>Last Name:</strong>' +
      '    </div>' +
      '    <div class="col">' +
      $('#lastName').val() +
      '    </div>' +
      '</div>' +
      '<div class="row col-12 mt-1">' +
      '    <div class="col-4" style="text-align: right;">' +
      '       <strong>Phone Number:</strong>' +
      '    </div>' +
      '    <div class="col">' +
      $('#phoneNumber').val() +
      '    </div>' +
      '</div>' +
      '<div class="row col-12 mt-1">' +
      '    <div class="col-4" style="text-align: right;">' +
      '       <strong>City:</strong>' +
      '    </div>' +
      '    <div class="col">' +
      $('#city').val() +
      '    </div>' +
      '</div>' +
      '<div class="row col-12 mt-1">' +
      '    <div class="col-4" style="text-align: right;">' +
      '       <strong>State:</strong>' +
      '    </div>' +
      '    <div class="col">' +
      $('#stateProvince').val() +
      '    </div>' +
      '</div>' +
      '<div class="row col-12 mt-1">' +
      '    <div class="col-4" style="text-align: right;">' +
      '       <strong>Notes:</strong>' +
      '    </div>' +
      '    <div class="col">' +
      $('#notes').val() +
      '    </div>' +
      '</div>' +
      '</div>' +

      '  <div class="container">' +

      '<div class="row col-12 mt-2">' +
      '    <div class="col" style="text-align: center; margin: 0;">' +
      '       By signing below, I am giving my permission to process this request.' +
      '    </div>' +
      '</div>' +
      '<div class="row col-12 mt-1">' +
      '    <div class="col-8">' +
      '       <strong>Consumer Signature (type full name)</strong>' +
      '    </div>' +
      '    <div class="col">' +
      '       <strong>Date</strong>' +
      '    </div>' +
      '</div>' +
      '<div class="row col-12">' +
      '    <div class="col-8">' +
      $('#signature').val() +
      '    </div>' +
      '    <div class="col">' +
      todaysDate +
      '    </div>' +
      '</div>' +
      '</div>' +
      '        <script src="https://ajax.googleapis.com/ajax/libs/jquery/1.12.4/jquery.min.js"></script>' +
      '        <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js" integrity="sha384-Tc5IQib027qvyjSMfHjOMaLkfuWVxZxUPnCJA7l2mCWNIpG9mGCD8wGNIcPD7Txa" crossorigin="anonymous"></script>' +
      '    </body>' +
      '</html>';
  }

  $('#uploadBtn').change(function () {
    $('#uploadFile').val(this.value.replace(/^.*\\/, ""))
    $('#uploadFileBtn').prop('disabled', false)
    console.log('uploadBtn')
    console.log($('#uploadBtn'))
    let allowedUploadTypes = []
    allowedUploadTypes.push('application/pdf')
    allowedUploadTypes.push('image/jpeg')
    allowedUploadTypes.push('image/png')
    if($(this)[0].files.length > 0){
      let uploadType = $(this)[0].files[0].type
      if (allowedUploadTypes.indexOf(uploadType) < 0) {
        $('#uploadFile').css('background-color', 'pink')
        $(this).val('')
        $('.file-caption-name').val('')
        $('#invalid-filetype').show()
        console.log($('#uploadBtn'))
      } else {
        $('#uploadFile').css('background-color', 'white')
        $('#invalid-filetype').hide()
      }

    } else {

    }
/*
    const file = $(this)[0].files[0];
    const reader = new FileReader();
    reader.onload = function() {
      // console.log('reader.result')
      // console.log(reader.result)
      uploadedFileMimeType = reader.result.split(',')[0].split(';')[0].replace('data:','');
      uploadedFileName = file.name;
      console.log('uploadedFileMimeType ' +uploadedFileMimeType)
      console.log('uploadedFileName ' +uploadedFileName)
      let base64File = reader.result.split(',')[1];
      getEncryptKey(base64File)
      publicKey = null
    };
    reader.readAsDataURL(file)
*/
  })

  function submitRequest() {
    $('#submitBtn').prop('disabled', true)
    $('#accepted').prop('disabled', true)
    $('#denied').prop('disabled', true)
    setHtmlValue()
    const consumerRequestForm = {
      content: html,
      data: {
        confirmDelete: $('#confirmDelete')[0].checked,
        emailAddress: $('#emailAddress').val(),
        fullName: $('#firstName').val() + " " + $('#lastName').val(),
        phoneNumber: $('#phoneNumber').val(),
        city: $('#city').val(),
        stateProvince: $('#stateProvince').val(),
        signature: $('#signature').val(),
      },
      type: 'ConsumerRequest',
      additionalFileStoreId: 0,
      userOriginData: sessionStorage.getItem("userOriginData")
    }
    console.log('consumerRequestForm')
    // console.log(consumerRequestForm)
    console.log('uploadFile')
    // console.log($('#uploadFile'))
    if ($('#uploadBtn')[0].files.length == 0) {
      submitForm(consumerRequestForm)
    } else {
      processFileSubmitForm(consumerRequestForm)
    }

  }

  async function processFileSubmitForm(consumerRequestForm){
    console.log('upload file')
    const file = $('#uploadBtn')[0].files[0];
    const reader = new FileReader();
    reader.onload = function() {
      // console.log('reader.result')
      // console.log(reader.result)
      uploadedFileMimeType = reader.result.split(',')[0].split(';')[0].replace('data:','');
      uploadedFileName = file.name;
      // console.log('uploadedFileMimeType ' +uploadedFileMimeType)
      // console.log('uploadedFileName ' +uploadedFileName)
      let readFile = reader.result.split(',')[1];
      $.ajax({
        url: apiUrl + 'webForm/GetWebFormKey',
        type: 'get',
        contentType: false,
        processData: false,
        success: function (response) {
          // console.log('key response')
          publicKey = response
          encryptedFile = encryptUploadFile(readFile,consumerRequestForm)
        },
        error: function (textStatus, errorThrown) {
          console.log(errorThrown)
        }
      })
    };
    reader.readAsDataURL(file)
  }

  async function encryptUploadFile(base64File,consumerRequestForm){
    // console.log('publicKey')
    // console.log(publicKey)
    // console.log('base64File')
    // console.log(base64File)
    let keyObj = await openpgp.readKey({armoredKey: publicKey})
    encryptedFile  = await openpgp.encrypt({
      message: await openpgp.createMessage({ text: base64File }),
      encryptionKeys: keyObj,
      format: 'armored'
    });
    // console.log('encryptedFile')
    // console.log(encryptedFile)

    const fd = new FormData();
    // console.log('encrypted file')
    // console.log(encryptedFile)
    fd.append('EncryptedFile', encryptedFile);
    fd.append('FileName', uploadedFileName);
    fd.append('MimeType', uploadedFileMimeType);
    console.log(fd)
    $.ajax({
      url: apiUrl + 'webForm/UploadWebFormFile',
      type: 'post',
      data: fd,
      contentType: false,
      processData: false,
      success: function (response) {
        console.log('file uploaded')
        // console.log(response)
        fileStoreId = response.fileStoreId
        consumerRequestForm.additionalFileStoreId = fileStoreId
        submitForm(consumerRequestForm)
      },
      error: function (textStatus, errorThrown) {
        console.log(errorThrown)
      }
    })
    publicKey = null
  }


  function disableSubmitButton() {
    if ($('#emailAddress').val() !== '' && $('#firstName').val() !== '' &&
      $('#lastName').val() !== '' && $('#phoneNumber').val() !== '' && $('#city').val() !== ''
      && $('#stateProvince').val() !== '' && $('#signature').val() !== '' && $('#confirmDelete')[0].checked) {
      $('#submitBtn').prop('disabled', false)
    }
  }
  // url: apiUrl + 'webForm',

  function submitForm(consumerRequestForm) {
    $.ajax({
      type: 'post',
      url: apiUrl + 'webForm',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(consumerRequestForm),
      success: function (data) {
        if (data.message === 'Web form has been processed.') {
          $('#confirmDelete')[0].checked = false
          $('#emailAddress')[0].value = ''
          $('#firstName')[0].value = ''
          $('#lastName')[0].value = ''
          $('#phoneNumber').value = ''
          $('#city').value = ''
          $('#stateProvince').value = ''
          $('#signature').value = ''



          const modal = document.getElementById('confirmation');
          // const markup = '<div class="container p-4" style="height: 100vh">' +
          //   '<div class="row">' +
          //   '<div class="col text-center">' +
          //   // '<i class="far fa-3x text-success fa-check-circle"></i>' +
          //   '</div></div>' +
          //   '      <div class="row">' +
          //   '        <div class="col text-center">\n' +
          //   '          <h2 class="font-weight-bold text-success">Your request has been successfully submitted!</h2>\n' +
          //   '        </div>\n' +
          //   '      </div>' +
          //   '</div>';
          //
          // $('#mainForm').html(markup);
                    if(!window.location.origin.includes('local')){
                      window.location.href = window.location.origin + '/web-forms/thank-you.html';
                    }else{
                      window.location.href = window.location.origin + '/thank-you.html';
                    }
          // setTimeout( () => {
          //   this.prompted = !this.prompted;
          //   location.reload();
          // }, 5000);
        } else {
          const modal = document.getElementById('confirmation');
          modal.innerHTML = '<div class="container p-4">' +
            '<div class="row">' +
            '<div class="col text-center">' +
            '<i class="fas fa-3x fa-exclamation-circle"></i>' +
            '</div></div>' +
            '      <div class="row">' +
            '        <div class="col text-center">\n' +
            '          <h2 class="font-weight-bold text-danger">An error has occurred. Please try again later.</h2>\n' +
            '        </div>\n' +
            '      </div>' +
            '</div>';

          this.consumerRequestForm.reset();
          // setTimeout( () => {
          //   this.prompted = !this.prompted;
          //   location.reload();
          // }, 5000);
          console.error(error);
        }
      }
    })
  }
}
